import { Component, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { configFormFields, delieryDaysNTimeConfig, disableOnHolidays, hoursConfig } from '../../../configs';
import { UntypedFormGroup } from '@angular/forms';
import { getTimeRange } from '../../../utils';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
  selector: 'app-days-n-times',
  templateUrl: './days-n-times.component.html',
  styleUrls: ['./days-n-times.component.scss'],
  standalone: false,
})
export class DaysNTimesComponent implements OnInit {
  @ViewChild('exp') exp: MatExpansionPanel;
  @Input() formGroup: UntypedFormGroup;
  @Input() showExpansionGuide: string;
  @Input() shopSettings;
  @Input() accordionActiveSection: string[];
  @Output() onOpenExpansionEmit = new EventEmitter<string>();
  @Output() onCloseExpansionEmit = new EventEmitter<void>();
  @Output() onExpandedNeededEmit = new EventEmitter<string>();
  disableOnHolidays = [...disableOnHolidays];
  deliveryDaysNTimeConfig = [...delieryDaysNTimeConfig];
  hours = [...hoursConfig];

  private readonly scheduleDefaults: Record<string, unknown> = Object.fromEntries(
    configFormFields.map((field) => [field.fieldName, field.defaultValue]),
  );

  constructor() {}

  ngOnInit() {
    this.initDeliveryDaysNTimesHours();
  }

  initDeliveryDaysNTimesHours() {
    this.deliveryDaysNTimeConfig.map((dayNtime) => {
      dayNtime.hours = this.hours;
      dayNtime.toHours = this.hours;
    });
  }

  // the schedule is hidden under 24/7, so leftover edits must not be saved or come back later
  onScheduleModeChange(alwaysActive: boolean): void {
    if (!alwaysActive) return;
    this.deliveryDaysNTimeConfig.forEach((day) => {
      [day.dayName, day.fromTimeFormControl, day.toTimeFormControl].forEach((controlName) =>
        this.getField(controlName)?.setValue(this.scheduleDefaults[controlName]),
      );
      day.toHours = this.hours;
    });
  }

  onHourChoose(event, index?: number): void {
    if (event) {
      const currentChanged = this.deliveryDaysNTimeConfig.find((day) => day.index == index);
      const currentTime = event.value.name;
      const currentIndex = event.value.value;
      currentChanged.toHours = getTimeRange(currentTime, currentIndex);
    }
  }

  // loaded times are strings, picked times are { name, value } options
  hoursCompareWith(option: { name: string }, selected: string | { name: string }): boolean {
    return option?.name === (typeof selected === 'string' ? selected : selected?.name);
  }

  getField(str: string): any {
    return this.formGroup.get(str);
  }

  compareWithDeliveryDaysAndTimesHolidays(obj1: any, obj2: any): boolean {
    return obj1.value == obj2;
  }

  onOpenExpansion(section: string): boolean {
    this.onOpenExpansionEmit.emit(section);
    return true;
  }

  onCloseExpansion(): void {
    this.onCloseExpansionEmit.emit();
  }

  isExpandedNeeded(section: string): boolean {
    return this.accordionActiveSection.some((value) => value == section);
  }
}
